import { css } from '@emotion/core';
import MediaQueries from '../../../styles/Grid/MediaQueries';
import { typography, fontWeights } from '../../../styles/typography';
import { colorsPalette, keyColors } from '../../../styles/colors';

export const spacerPaddingCss = css({
  padding: '48px 0 8px',
  [MediaQueries.mdAndUp]: {
    padding: '96px 0 59px',
  },
  [MediaQueries.xl]: {
    padding: '128px 0 119px',
  },
});

export const spacerMarginCss = css({
  margin: '48px 0 8px',
  [MediaQueries.mdAndUp]: {
    margin: '96px 0 59px',
  },
  [MediaQueries.xl]: {
    margin: '128px 0 119px',
  },
});

export const headlineCss = css(typography.effra48, {
  marginBottom: 32,
  position: 'relative',
  fontWeight: fontWeights.medium,
  [MediaQueries.mdAndUp]: {
    marginBottom: 48,
  },
});

export const itemCss = theme => {
  const isDarkTheme = theme === keyColors.black;
  const { brown40, grey90 } = colorsPalette;
  const lightBorder = `1px solid ${brown40}`;
  const darkBorder = `1px solid ${grey90}`;

  return css({
    paddingBottom: 29,
    borderBottom: isDarkTheme ? darkBorder : lightBorder,
    marginBottom: 32,
    [MediaQueries.mdAndUp]: {
      paddingBottom: 8,
      marginBottom: 23,
    },
    [MediaQueries.xl]: {
      paddingBottom: 5,
      marginBottom: 36,
    },
  });
};

export const linkCss = css({
  color: colorsPalette.white,
});

export const solutionHeadlineCss = css(typography.effra28, {
  marginBottom: 16,
  [MediaQueries.mdAndUp]: {
    marginBottom: 9,
  },
  [MediaQueries.xl]: {
    marginBottom: 12,
  },
});

export const containerCss = css({
  [MediaQueries.mdAndUp]: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
});

export const shortDescriptionCss = theme => {
  const isDarkTheme = theme === keyColors.black;
  const { grey20, grey60 } = colorsPalette;

  return css(typography.effra16, {
    color: isDarkTheme ? grey20 : grey60,
    marginBottom: 17,
    [MediaQueries.mdAndUp]: {
      maxWidth: '75%',
    },
  });
};
